import React, { useEffect, useRef, useState } from 'react'
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import "../../Assets/css/custom.css";
import noimage from '../../Assets/images/no-image-found.jpg'

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import Modal from 'react-bootstrap/Modal';
import { api_url } from '../../Constants/web_services';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

const RecentProjects = ({ company }) => {

    const [companyData] = useState(company);
    const [fullscreen] = useState(true);
    const [show, setShow] = useState(false);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);
    const videoRef = useRef(null);

    useEffect(() => {
        const player = new Plyr(videoRef.current, {
            controls: ['play', 'progress', 'current-time', 'mute', 'volume'],
            disableDownload: true,
        });

        return () => {
            if (player) {
                player.destroy();
            }
        };
    }, [videoRef]);

    function handleShow(id) {
        console.log(id)
        setSelectedProjectId(id);
        setShow(true);
    }

    // const handleModalOff = () => {
    //     setSelectedProjectId(null);
    //     setShow(false)
    // }
    useEffect(() => {
        if (selectedProjectId !== null) {
            // Find the selected project data based on selectedProjectId
            const project = companyData?.recent_project?.find(project => project.id === selectedProjectId);
            setSelectedProject(project);
        }
    }, [selectedProjectId, companyData]);

    if (!companyData?.recent_project) {
        return "no projects found";
    };

    return (
        <>

            <div className="container" id="aon-provider-video">
                {/*Video*/}
                <div

                    className="sf-provi-vido-box margin-b-50 "
                >
                    <h3 className="sf-provi-title s-22 fw-800 text-drk-primary">Projects</h3>
                    <div className="sf-divider-line" />


                    <Swiper
                        className='pb-5 '
                        // install Swiper modules
                        modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
                        autoplay={{
                            delay: 2500, // Time in milliseconds for the delay between slides
                            disableOnInteraction: false, // Continue autoplay after user interactions
                        }}
                        breakpoints={{
                            320: {
                                spaceBetween: 5,
                                slidesPerView: 1,
                            },
                            // when window width is >= 576px
                            576: {
                                spaceBetween: 5,
                                slidesPerView: 1,
                            },
                            // when window width is >= 768px
                            768: {
                                spaceBetween: 5,
                                slidesPerView: 2,
                            },
                            // when window width is >= 1024px
                            1024: {
                                spaceBetween: 5,
                                slidesPerView: 3,
                            },
                            1280: {
                                spaceBetween: 5,
                                slidesPerView: 3,
                            },
                        }}
                        pagination={{ clickable: true }}
                    // onSwiper={(swiper) => console.log(swiper)}
                    // onSlideChange={() => console.log('slide change')}
                    >
                        {companyData?.recent_project?.length > 0 ? (
                            companyData?.recent_project.map((recPro, index) => (
                                <SwiperSlide key={`slider_${recPro.id}`}>
                                    <div className="col-md-12 shadow-sm">
                                        {/* COLUMNS 1 */}
                                        <div className="item">
                                            <div className="sf-video-box sf-videoBox-full">
                                                <div className="sf-video-pic">
                                                    <img src={api_url + '/' + recPro?.image} alt={recPro?.id} />
                                                </div>
                                                <div
                                                    onClick={() => handleShow(recPro?.id)}
                                                    className="sf-video-play-btn mfp-video cursor-pointer"
                                                >
                                                    <i className="fas fa-info-circle" />
                                                </div>
                                            </div>
                                        </div>
                                        <p className='fw-600 text-022278'>{recPro?.title}</p>
                                    </div>
                                </SwiperSlide>
                            ))
                        ) : (
                            <div className="row justify-content-center">
                                <div className="col-lg-4 col-md-4">
                                    <div className="loader">
                                        <div className="loader-text">No Projects available...</div>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Swiper>


                </div>
            </div>
            {selectedProject && (
                <Modal show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
                    <Modal.Body className='p-0 px-0 position-relative'>

                        <div className="page-content">
                            <div className="sf-profile-banner-full">
                                <div className="container-fluid sf-proBnrfull-container p-0">
                                    <div className="sf-proBnrfull-row">
                                        {/*Top Banner Left*/}
                                        <div className="position-absolute end-0 mt-5">
                                            <button onClick={() => setShow(false)} className="btn btn-close-modal mt-2">
                                                <i className="fa fas fa-reply mt-5 text-warning" style={{ fontSize: '30px' }}></i>
                                            </button>
                                        </div>
                                        <div className=" sf-proBnrfull-left col-md-6 p-1">

                                            <img
                                                src={selectedProject?.cover_img ? `${api_url}/${selectedProject.cover_img}` : noimage}
                                                style={{ width: '660px', height: '900px' }}
                                                alt='Project Images'
                                                onError={(e) => e.target.src = noimage} // Fallback image on error
                                            />

                                        </div>
                                        {/*Top Banner Right*/}
                                        <div className=" sf-proBnrfull-right">

                                            <h2 className=" sf-proBnrfull-heading">{selectedProject?.title}</h2>
                                            <div className=" sf-proBnrfull-tagline text-warning">
                                                {selectedProject?.short_desc}
                                            </div>
                                            <br />
                                            <div className=" sf-proBnrfull-tagline" style={{ fontSize: '15px' }}>
                                                {selectedProject?.description}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row justify-content-center video-bg">
                                        <h2 className='video-heading text-center text-capitalize pt-4 pb-4 text-warning'>sample project video</h2>
                                        <div className="col-md-8 text-center  mt-3 video-c">
                                            <video ref={videoRef} >
                                                <source src={api_url + '/' + selectedProject?.video} />
                                            </video>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </Modal.Body>
                </Modal>
            )}

        </>
    )
}

export default RecentProjects


